import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CUSTOMER_CONTACT_TABS } from '../contact-tabs';

@Component({
    selector: 'contact-list',
    templateUrl: 'contactList.component.html',
  standalone: false
})


export class ContactListComponent implements OnInit {
    readonly tabs = CUSTOMER_CONTACT_TABS;
    constructor(
        private route: Router,
        private activatedRoute: ActivatedRoute
    ) { }


    ngOnInit(): void {
        document.querySelector("body").classList.remove("opened");
        // A deep link, such as a tab picked in the hover sub-navigation, keeps its tab.
        if (!this.activatedRoute.firstChild) {
            this.route.navigate([this.tabs[0].linkText], { relativeTo: this.activatedRoute });
        }
    }

    saveChange() {
    }
}

